import { IMemoModel } from './memo.model';
import { IAlert } from './alert.model';
import { ISeatingConfigurationModel } from './seating-configuration.model';
import { ITurnaround } from './turnaround.model';
import { ILegsFirestoreModel } from './legs.firestore.model';

// delays
// seating configuration
// UI filters - Airport ID + code - hasAlerts(boolean) - hasMessages(boolean) - Status - STD+ETA+ETD + Date of operation + AC Registration
export interface IPairDetail {
  id?: number;
  status?: string;
  arrivalLeg?: ILegsFirestoreModel;
  departureLeg?: ILegsFirestoreModel;
  dateOfOperation?: Date;
  acRegistration?: string;
  airportGate?: string;
  aircraftStand?: string;

  ctot?: Date;

  //messages?: any[];
  //errors?: any[];
  arrivalMemos?: IMemoModel[];
  departureMemos?: IMemoModel[];
  arrivalAlerts?: IAlert[];
  departureAlerts?: IAlert[];

  locked?: any;

  processes?: any[];

  seatingConfiguration?: ISeatingConfigurationModel[];
  arrivalDelays?: { delayCode: string, minutes: number }[];
  departureDelays?: { delayCode: string, minutes: number }[];

  airportCode?: string;
  hasAlerts?: boolean;
  hasMessages?: boolean;
  hasMemo?: boolean;
  std?: Date;
  sta?: Date;
  etd?: Date;
  eta?: Date;
  atd?: Date;
  ata?: Date;
  tot?: Date;
  landingTime?: Date;
  turnaround?: ITurnaround;
}

export function isPairDetail(pair: any): pair is IPairDetail {
  return 'arrivalLeg' in pair || 'departureLeg' in pair;
}
